export enum TransportadorasTypes {
  'LOAD_REQUEST' = '@transportadoras/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@transportadoras/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@transportadoras/LOAD_FAILURE',

  'SELECT_REQUEST' = '@transportadoras/SELECT_REQUEST',
  'SELECT_SUCCESS' = '@transportadoras/SELECT_SUCCESS',

  'SELECT_TRANSPORTADORA_PARCEIRA_REQUEST' = '@transportadoras/SELECT_TRANSPORTADORA_PARCEIRA_REQUEST',
  'SELECT_TRANSPORTADORA_PARCEIRA_SUCCESS' = '@transportadoras/SELECT_TRANSPORTADORA_PARCEIRA_SUCCESS',

  'CRIAR_TRANSPORT_REQUEST' = '@transportadoras/CRIAR_TRANSPORT_REQUEST',
  'CRIAR_TRANSPORT_SUCCESS' = '@transportadoras/CRIAR_TRANSPORT_SUCCESS',
  'CRIAR_TRANSPORT_FAILURE' = '@transportadoras/CRIAR_TRANSPORT_FAILURE',

  'VERIFICAR_TRANSPORT_REQUEST' = '@transportadoras/VERIFICAR_TRANSPORT_REQUEST',
  'VERIFICAR_TRANSPORT_SUCCESS' = '@transportadoras/VERIFICAR_TRANSPORT_SUCCESS',
  'VERIFICAR_TRANSPORT_FAILURE' = '@transportadoras/VERIFICAR_TRANSPORT_FAILURE',

  'CLEAR_TRANSP_SELECT' = '@transportadoras/CLEAR_TRANSP_SELECT',

  'CLEAN_SELECT' = '@transportadoras/CLEAN_SELECT',
}

export interface ITranspSelecionada {
  codParceiro: number;
  nomeParceiro: string;
  isPadrao: boolean;
}

export interface IVerificarTransp {
  codParceiro: number;
  nomeParceiro: string;
  cnpj: string;
  codCidade: number;
  cidade: string;
  codUf: number;
  uf: string;
}

export interface ICriarTransp {
  cnpj: string;
  nome: string;
  codCid: number;
  codParceiro: number;
}

export interface TransportadorasState {
  readonly data: ITranspSelecionada[];
  readonly selecionada?: ITranspSelecionada;
  readonly transportadoraParceira?: ITranspSelecionada;
  readonly loading: boolean;
  readonly loadingCriaTransp: boolean;
  readonly error: boolean;
  readonly criarTransportadora?: ICriarTransp;
  readonly verificarTransportadora: IVerificarTransp[];
}
